import * as React from 'react';
import styled from 'react-emotion';
import { connect } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { AppProps, IAppDispatchProps, IAppStateProps } from './App.d';
import Header from './components/Header';
import {
  adminPaths,
  adminRoutes,
  ownerPaths,
  ownerRoutes,
  staffPaths,
  staffRoutes,
  userPaths,
  userRoutes,
} from './Routes';
import { IState } from './store';
import { watchForCurrentUser } from './store/actions';
import Home from './views/Home';

const AppContainer = styled('div')`
  font-family: sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: center;
  max-width: 100vw;
  min-height: 100vh;
  padding-top: 50px;
`;
AppContainer.displayName = 'AppContainer';
const AppBody = styled('div')`
  flex: 1;
  display: flex;
  width: 1280px;
  max-width: 100vw;
`;
AppBody.displayName = 'AppBody';

class App extends React.Component<AppProps> {
  public componentDidMount() {
    const { onWatchForCurrentUser } = this.props;

    onWatchForCurrentUser();
  }

  public render() {
    const {
      currentUser,
      permissions,
      permissions: { role },
    } = this.props;
    const linkPaths =
      role === 'staff'
        ? staffPaths
        : role === 'owner'
          ? ownerPaths
          : role === 'admin'
            ? adminPaths
            : userPaths
    const routes =
      role === 'admin'
        ? adminRoutes
        : role === 'owner'
          ? ownerRoutes
          : role === 'staff'
            ? staffRoutes
            : userRoutes;

    return (
      <BrowserRouter>
        <AppContainer>
          <Header {...{ linkPaths }} />
          <AppBody>
            <Switch>
              {routes}
              <Route path="/">
                <Home currentUser={currentUser} permissions={permissions} />
              </Route>
            </Switch>
          </AppBody>
        </AppContainer>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = ({ users: { currentUser, permissions } }: IState) => ({
  currentUser,
  permissions,
});

const mapDispatchToProps = {
  onWatchForCurrentUser: watchForCurrentUser,
};

export default connect<IAppStateProps, IAppDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(App);



// WEBPACK FOOTER //
// ./src/App.tsx